import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  panel: {
    background: 'none',
    boxShadow: 'none',

    '&:before': {
      display: 'none',
    },
  },
  panelExpanded: {
    margin: 'auto !important',
  },
  panelSummary: {
    minHeight: 'auto !important',
  },
  panelSummaryContent: {
    margin: '0 !important',
  },
  panelDetails: {
    display: 'block',
  },
}));
